// extracted by mini-css-extract-plugin
export var container = "_f1-1";
export var cornerButtonContainer = "_f1-6";
export var disabled = "_f1-2";
export var dragActive = "_f1-3";
export var fileContainer = "_f1-5";
export var hiddenInput = "_f1-4";
export var widthContainer = "_f1-0";